import {absCenter, svg_md} from '@xpertdox_js/xdstyle';
import {colors} from '../../defaultSettings';

export default {
  nativeBuffer: {
    fill: colors.highlight,
    color: colors.highlight
  },
  nativeSVG: {
    ...svg_md,
    margin: '0 auto',
    opacity: .4,
    transition: '.24s'
  },
  nativeSVGAct: {
    opacity: 1,
  },
  groupCount: {
    position: 'absolute',
    right: '1px',
    left: 'auto',
    top: '1px',
    width: '14px',
    height: '14px',
    transition: '.24s',
    opacity: .4,
  },
  groupCountAct: {
    opacity: 1,
  },
  groupCountText: {
    ...absCenter,
    display: 'block',
    fontSize: '1rem',
  },
}
